import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { handleEditClose } from "../../redux/Reducer/ModalSlice";

function EditModal({ children, ModalWidth, ModalTitle }) {
  const edit = useSelector((state) => state.Modal.edit);
  const dispatch = useDispatch();

  return (
    <Dialog
      open={edit}
      fullWidth={true}
      maxWidth={ModalWidth}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <span
          style={{
            color: "#4187e8",
          }}
        >
          {ModalTitle}
        </span>
        <CloseIcon
          sx={{ mt: "5px", cursor: "pointer" }}
          onClick={() => {
            dispatch(handleEditClose());
          }}
        />
      </DialogTitle>
      <DialogContent dividers style={{ padding: " 0px" }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default EditModal;
